<template>
  <div class="city">
    <!--导航部分-->
    <div class="dk-nav" style="padding-bottom: 46px;">
      <van-nav-bar
        fixed
        title="全国城市"
        left-arrow
        :left-text="city"
        @click-left="onClickLeft"
      />
    </div>

    <!--城市列表-->
    <div class="bj-city">
      <div class="bj-city-search">
        <van-search placeholder="请输入城市名称" v-model="filterInput" />
      </div>
      <!--城市列表页面-->
      <template v-if="!filterInput">
        <div class="bj-city-location">
           <div class="van-cell">
             <i class="van-icon van-icon-location-o van-cell__left-icon"></i>
             <div class="van-cell__title">
               当前定位：<span style="color: #ff8917">{{cityName}}</span>
             </div>
             <div class="van-cell__value" @click="goLocation()">
              <span>重新定位</span>
             </div>
           </div>
        </div>
        <template v-if="loading">
          <div class="bj-city-hot">
            <van-grid :column-num="3" gutter="6">
              <van-grid-item
                      v-for="item in cityList.hotCities"
                      :key="item.code"
                      :text="item.name"
                      @click="selectArea(item.name)"
              />
            </van-grid>
          </div>
          <div class="bj-city-list">
            <van-index-bar highlight-color="#ff8917" :index-list="indexList" :sticky="false" :sticky-offset-top="130">
              <div v-for="(item,index) of cityList.city" :key="index">
                <van-index-anchor :index="indexList[index]">{{item.initial}}</van-index-anchor>
                <van-cell v-for="subItem of item.list" :key="subItem.code" @click="selectArea(subItem.name)">{{subItem.name}}</van-cell>
              </div>
            </van-index-bar>
          </div>
        </template>
        <template v-else>
          <div class="loading">
            <van-loading type="spinner" color="#ff8917" vertical />
          </div>
        </template>
      </template>
      <!--搜索城市列表页面-->
      <template v-else>
        <div class="bj-city-list">
          <div v-for="(item,index) of cityList.city" :key="index">
            <van-cell v-for="subItem of filterBy(item.list,filterInput)" :key="subItem.code" @click="selectArea(subItem.name)">{{subItem.name}}</van-cell>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import Axios from 'axios';
import {mapState} from 'vuex';
import Store from '../../store/store'
import { getLocation } from "../../utils/location"
import NavBar from '../../components/NavBar.vue'
export default {
    'name': 'City',
    data() {
        return {
            loading: false,
            indexList: [],
            cityList: [],
            cityName: '',
            filterInput: '',
            hasNoData: false
        };
    },
    computed: {
        ...mapState({
            city: state => state.cityData.city,
            current: state => state.currentCity,
            lng: state => state.cityData.lng,
            lat: state => state.cityData.lat
        })
    },
    methods: {
        goUrl(val) {
            return this.$router.push({path: val})
        },
        backTop() {
            document.body.scrollTop = 0
            document.documentElement.scrollTop = 0
        },
        selectArea(val) {
            this.cityName= val;
            this.filterInput = '';

            let data = {
                province: '',
                city: val,
                district: '',
                lat: this.lat,
                lng: this.lng
            }

            Store.commit("UPDATE_CHANGE_CITY",data)
            localStorage.setItem("city_data",JSON.stringify(data))

            // this.backTop(); 禁止上滑

            return this.$router.push({path: '/home'});

        },
        getCityData() {
            Axios.get('../../../static/city.json').then(response => {
                this.loading = true
                this.indexList = response.data.indexList
                this.cityList = response.data
                this.list = response.data
            }).catch(error => {
                this.$toast.fail({
                    duration: 800,
                    message: "系统异常"
                });
            })
        },
        filterBy(list,value){
            return list.filter(function(lists){
                return lists.name.match(value);
            })
        },
        onClickLeft() {
            return this.$router.push({path:'/home'})
        },
        goLocation() {
         // getLocation();
          this.$toast.loading({
            message: '定位中...',
            forbidClick: true,
            loadingType: 'spinner',
          });

          return window.location.href="/" ;
        }
    },
    components: {
        NavBar
    },
    mounted () {
        this.getCityData();
        this.cityName = this.current;
    }
};
</script>

<style scoped>

/*导航*/
.city >>> .van-nav-bar {
  z-index: 9;
  background: #ff8917;
  padding-top: 6px;
}
.city >>> .van-nav-bar .van-icon {
  color: #fff;
}
.city >>> .van-nav-bar__title {
  color: #fff;
}
.city >>> .van-nav-bar__text {
  color: #fff;
}

  /* 列表样式 */
  .city >>> .van-grid-item__content {
    padding: 0.2rem 0.21333rem;
  }
  .bj-city-hot {
    padding: 10px 26px 10px 10px;
  }
  .city >>> .van-grid-item__text {
    color: #333;
    font-size: 0.38rem;
  }
  .bj-city-list {
    background: #f6f6f6;
  }
  .city >>> .van-index-bar__index {
    padding: 5px 2px 0 10px;
    font-size: 0.38rem;
    line-height: 0.44rem;
  }
  .city >>> .van-index-bar__sidebar {
    top: 53%;
  }
  .city >>> .van-cell {
    font-size: 0.38rem;
  }
  .city >>> .van-index-anchor {
    font-size: 0.38rem;
  }
  .city >>> .van-search {
    padding-top: 0.5rem;
    padding-bottom: 0.06rem;
    padding-left: 0.32rem;
    padding-right: 0.32rem;
  }

  .loading {
    width: 100%;
    margin: 20px auto 0 auto;
    text-align: center;
  }
</style>
